import { Timeline as AntdTimeline } from 'antd';
import React from 'react';

const Timeline = ({
  items = [],
  mode = 'left',
  pending = false,
  pendingDot = null,
  reverse = false,
  size = 'default',
  className = '',
}) => (
  <AntdTimeline
    items={items}
    mode={mode}
    pending={pending}
    pendingDot={pendingDot}
    reverse={reverse}
    size={size}
    className={className}
  />
);

export default Timeline;
